import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import {
  GetShoppingListsAction,
  CreateShoppingListAction,
  UpdateShoppingListAction,
  GetMyProjectsAction,
  DeleteProjectAction
} from '../../types/actions/ProjectBuilderAction';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';

export type ProjectBuilderActions = {
  getMyProjects: GetMyProjectsAction;
  getShoppingLists: GetShoppingListsAction;
  createShoppingList: CreateShoppingListAction;
  updateShoppingList: UpdateShoppingListAction;
  getMyProjectsDashboard: GetMyProjectsAction;
  getProjectById: GetMyProjectsAction;
  performMutationOnMyProjectById: UpdateShoppingListAction;
  deleteProject: DeleteProjectAction;
  updateProjectStatus:UpdateShoppingListAction;
};

export const getProjectBuilderAction = (sdk: SDK<ComposableCommerceEvents>): ProjectBuilderActions => {
  return {
 
    getShoppingLists: async (
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getShoppingLists',
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    getMyProjects: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getMyProjects',
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    getMyProjectsDashboard: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getMyProjectsDashboard',
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    getProjectById: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/getMyProjectById',
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    performMutationOnMyProjectById: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/performMutationOnMyProjectById',
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    createShoppingList: async (
      payload: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/createShoppingList',
        payload,
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    updateShoppingList: async (
      payload: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/updateShoppingList',
        payload,
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },

    deleteProject: async (
      payload?: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/deleteProject',
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    updateProjectStatus: async (
      payload: any,
      options: {
        skipQueue?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<any>({
        actionName: 'projectBuilder/updateProjectStatus',
        payload,
        skipQueue: options.skipQueue,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });
      return response;
    },
  };
};
